export default class LearningHistoryTermsResult {
  correctTermsCount: number;
  incorrectTermsCount: number;
  goalCount: number;

  constructor(
    correctTermsCount: number,
    incorrectTermsCount: number,
    goalCount: number
  ) {
    this.correctTermsCount = correctTermsCount;
    this.incorrectTermsCount = incorrectTermsCount;
    this.goalCount = goalCount;
  }

  static fromJson(json: any): LearningHistoryTermsResult {
    const correctCount = json.correctTermsCount ?? 0;
    const incorrectCount = json.incorrectTermsCount ?? 0;
    const goalCount = json.goalCount ?? 0;
    return new LearningHistoryTermsResult(
      correctCount,
      incorrectCount,
      goalCount
    );
  }
}
